export const ManageRouting = [
  {
    path: "/material/manage/list",
    name: "material-manage-list",
    meta: { title: "仓库管理" },
    component: () => import("@/views/material/manage/list/index.vue"),
  },
  {
    path: "/material/manage/inventory-material/list",
    name: "material-manage-inventory-material-list",
    meta: { title: "库存管理" },
    component: () => import("@/views/material/manage/inventory-material/index.vue"),
  },
  {
    path: "/material/manage/project-material/list",
    name: "material-manage-project-material-list",
    meta: { title: "项目材料清单" },
    component: () => import("@/views/material/manage/project-material/index.vue"),
  },
  {
    path: "/material/manage/entry-exit-records/list",
    name: "material-manage-entry-exit-records-list",
    meta: { title: "出入库记录" },
    component: () => import("@/views/material/manage/entry-exit-records/index.vue"),
  },
];